import { GsFormSchema } from 'libs/shared/src/components/gs-form/interfaces/gs-form-schema';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the checkout guest gateway component form.
 * Defines the fields to display for the form.
 */
export const CHECKOUT_GUEST_GATEWAY_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    {
      formControlName: 'buttons',
      label: 'components.checkoutGuestGateway.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
